import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {CustomCellEditorComponent} from '../custom-cell-editor/custom-cell-editor.component';
import {ColorPickerDirective, ColorPickerModule} from 'ngx-color-picker';

@Component({
  selector: 'app-color-cell-editor',
  templateUrl: './color-cell-editor.component.html',
  styleUrls: ['./color-cell-editor.component.scss'],
  standalone: true,
  imports: [ColorPickerModule],
})
export class ColorCellEditorComponent extends CustomCellEditorComponent implements AfterViewInit {
  @ViewChild(ColorPickerDirective) colorPickerComponent: ColorPickerDirective;
  toggle: boolean;

  override ngAfterViewInit() {
    // focus on the input
    setTimeout(() => {
      this.colorPickerComponent.openDialog();
    });
  }

  override isPopup(): boolean {
    return true;
  }

  onColorPickerClosed($event: string) {
    if ($event !== this.textFormControl.value) {
      this.textFormControl.patchValue($event);
      this.saveValue();
    }
    this.params.stopEditing();
  }
}
